module.exports = __webpack_public_path__ + "static/media/product22.1bc2780a.jpg";